import { autoinject, bindable } from 'aurelia-framework';

interface IExpression {
	name: string;
	value: string;
	selectionStart: number;
	selectionEnd: number;
}

@autoinject
export class FormulaInput {
	@bindable fieldName: string;
	@bindable fieldValue: string;

	formulaField: HTMLInputElement;
	showGuide: boolean;
	availableExpressions: IExpression[];
	timeout: any;

	constructor() {
		this.showGuide = false;
		this.availableExpressions = [
			new MeasureExpression(),
			new PopulationExpression(),
			new PopulationByAgeExpression(),
			new AccountClassExpression(),
			new AccountGroupExpression(),
			new AccountTagExpression(),
			new DaysExpression(),
			new PerformanceIndicatorExpression() ];
	}

	onFocus() {
		this.showGuide = true;
	}

	onBlur() {
	}

	addOnFormula(expression: IExpression) {
		const indexOfCaret = this.formulaField.selectionStart;
		const value = this.formulaField.value;
		const output = [value.slice(0, indexOfCaret), expression.value, value.slice(indexOfCaret)].join('');
		this.formulaField.value = output;

		this.formulaField.focus();

		if (expression.selectionStart) {
			this.formulaField.selectionStart = indexOfCaret + expression.selectionStart;
			this.formulaField.selectionEnd = indexOfCaret + expression.selectionEnd;	
		}
	}
	
	closeHelper(): void {
		this.showGuide = false;
	}

	handleClose(e: KeyboardEvent) {
		e.stopPropagation();
		if (e.code === "Space" || e.code === "Enter") {
			this.closeHelper();
		}
	}

	attached() {
		this.formulaField.addEventListener("focus", () => this.onFocus(), true);
		this.formulaField.addEventListener("blur", () => this.onBlur(), true);
	}
}

class MeasureExpression implements IExpression {
	name = "Suorite";
	value = "Measure('tunniste')";
	selectionStart = 9;
	selectionEnd = 17;
}
class PopulationExpression implements IExpression {
	name = "Asukasluku";
	value = "Population()";
	selectionStart = 12;
	selectionEnd = 12;
}
class PopulationByAgeExpression implements IExpression {
	name = "Asukasluku/ikäryhmä";
	value = "PopulationByAge(alkaen, päättyen)";
	selectionStart = 16;
	selectionEnd = 35;
}
class DaysExpression implements IExpression {
	name = "Kauden pituus";
	value = "Days()";
	selectionStart = 6;
	selectionEnd = 6;
}
class AccountClassExpression implements IExpression {
	name = "Tililuokka";
	value = "AccountClass('tunniste')";
	selectionStart = 14;
	selectionEnd = 22;
}
class AccountGroupExpression implements IExpression {
	name = "Tiliryhmä";
	value = "AccountGroup('tunniste')";
	selectionStart = 14;
	selectionEnd = 22;
}
class AccountTagExpression implements IExpression {
	name = "Tilitunniste";
	value = "AccountTag('tunniste')";
	selectionStart = 12;
	selectionEnd = 20;
}
class PerformanceIndicatorExpression implements IExpression {
	name = "Tunnusluku";
	value = "PerformanceIndicator('id')";
	selectionStart = 22;
	selectionEnd = 24;
}
